import { ApiClient } from "../../ApiClient";
import { GetBrandsListResponse } from "../schema/GetBrandsListResponse";
import { mapBrandList } from "../../mappers/brands/brandListMapper";
import { BrandList } from "@/@types";

export const getBrandList = async (): Promise<BrandList[]> => {

    const client = ApiClient.getInstance()

    const response = await client.get<GetBrandsListResponse>('brands/list')

    const mappedResponse = mapBrandList(response.data)

    return mappedResponse;

}